"use client"

import { AlignStartVertical } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `AlignStartVerticalIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const AlignStartVerticalIcon = component(Icon)({
  as: AlignStartVertical,
})
